if (!customElements.get('product-sale-offer')) {
  customElements.define('product-sale-offer', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, ({data}) => {
        if (String(data.productId) !== this.dataset.productId || !data.sectionId || !data.sectionId.includes('__main')) return;
        const variant = data.variant;
        const discount = variant && variant.compare_at_price > variant.price
          ? Math.min(50, Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)) : 0;
        this.hidden = discount <= 0;
        this.querySelector('[data-offer-percent]').textContent = discount + '%';
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
